<template>
<div>
	<v-dialog
		v-model="dialog"
		width="500"
		persistent
	>
		<v-btn
			slot="activator"
			color="indigo"
			dark
			class="finance-pay-button"
		>
			{{$t('payments_types.type_' + type)}}
		</v-btn>

		<v-card>
			<v-card-title
				class="headline light-blue darken-1 white--text"
				primary-title
			>
				{{$t('payments_types.type_' + type)}}
			</v-card-title>

			<v-card-text>
				<v-container grid-list-lg>
					<v-layout>
						<v-flex md12>
							<v-layout column>
								<v-flex>
									<v-text-field type="number"
										class="inputPrice"
										:label="$t('common.sum')"
										v-model.number="formData.amount"
									/>
								</v-flex>
								<v-flex>
									<v-text-field :label="$t('common.comment')"
										v-model="formData.comment"
									/>
								</v-flex>
								<v-flex class="pay-btn" d-flex>
									<ConfirmDialog @accept="prepay" v-bind="propConfirm">
										{{$t('workers.pay')}}
									</ConfirmDialog>
								</v-flex>
							</v-layout>
						</v-flex>
					</v-layout>
				</v-container>
			</v-card-text>

			<v-divider />

			<v-card-actions>
				<v-spacer />
				<v-btn
						color="red light-1"
						flat
						@click="cancel"
				>
					{{$t('common.cancel')}}
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import { TEMPLATE_PREPAY } from '../../../../constants'
import { notify } from '../../../../utils/notifications'

export default {
	components: {
		ConfirmDialog
	},
	props: ['type'],
	data: (vm) => ({
		dialog: false,
		formData: { ...TEMPLATE_PREPAY },
		propConfirmDialog: {
			message: vm.$t('workers.prepayment.confirm_payment_' + vm.type),
			title: vm.$t('workers.prepayment.confirm_payment_title_' + vm.type),
			btnProps: {
				dark: true,
				large: true,
				color: 'green lighten-2'
			}
		}
	}),
	computed: {
		workerName() {
			const worker = this.$store.state.workers.workerDetail
			return worker.firstname + ' ' + worker.lastname
		},
		propConfirm() {
			return {
				...this.propConfirmDialog,
				message: this.$t('workers.confirm_prepayment', {
					amount: this.formData.amount,
					workerName: this.workerName,
					comment: this.formData.comment
				})
			}
		}
	},
	methods: {
		...mapActions({
			makePrepay: 'workers/makePrepay'
		}),
		prepay() {
			this.makePrepay({ ...this.formData, type: this.type }).then(() => {
				this.$notify({...notify, text: this.$t('notifications.saved', {type: 'prepayment'})})
			})
			this.cancel()
		},
		cancel() {
			this.dialog = false
			this.clearForm()
		},
		clearForm() {
			this.formData = { ...TEMPLATE_PREPAY }
		}
	}
}
</script>

<style>
.pay-btn .v-dialog__activator {
	display: flex;
	align-items: center;
	justify-content: center;
	padding-top: 25px;
}
</style>
